/**
 * @file: Fridge.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 冰箱绑定管理
 */
import request from '@/utils/request'

/**
 * 添加冰箱绑定信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function fridgeConfigAdd(data) {
  return request({
    type: 'device',
    url: 'fridge/config/add',
    method: 'post',
    data
  })
}

/**
 * 删除冰箱绑定信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function fridgeConfigDelete(data) {
  return request({
    type: 'device',
    url: 'fridge/config/delete',
    method: 'post',
    data
  })
}

/**
 * 获取冰箱绑定信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function fridgeConfigGet(data) {
  return request({
    type: 'device',
    url: 'fridge/config/get',
    method: 'post',
    data
  })
}

/**
 * 删除冰箱前判断是否绑定人员，绑定人员不允许删除(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function fridgeConfigJudgeDelete(data) {
  return request({
    type: 'device',
    url: 'fridge/config/judge/delete',
    method: 'post',
    data
  })
}

/**
 * 获取冰箱绑定列表信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function fridgeConfigListGet(data) {
  return request({
    type: 'device',
    url: 'fridge/config/list/get',
    method: 'post',
    data
  })
}

/**
 * 修改冰箱绑定信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function fridgeConfigUpdate(data) {
  return request({
    type: 'device',
    url: 'fridge/config/update',
    method: 'post',
    data
  })
}

/**
 * 添加冰箱和人员的绑定信息（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function fridgeConfigUserAdd(data) {
  return request({
    type: 'device',
    url: 'fridge/config/user/add',
    method: 'post',
    data
  })
}

/**
 * 获取冰箱绑定的人员列表信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function fridgeUserListGet(data) {
  return request({
    type: 'device',
    url: 'fridge/user/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Fridge.js